import { graphql } from "react-relay";

export const RunBindingMutation = graphql`
  mutation RunBindingMutation($input: RunBindingInput!) {
    runBinding(input: $input) {
      binding {
        name
        uuid
      }
    }
  }
`;
